import { render } from "./GreenCirclePreloader.vue?vue&type=template&id=4c5e9bae&scoped=true"
const script = {}

import "./GreenCirclePreloader.vue?vue&type=style&index=0&id=4c5e9bae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5e9bae"]])

export default __exports__